const { navigationRef } = require('helpers/navigation');

export const getOnDoneRouteConfig = () => navigationRef.current.getCurrentRoute();
